import angular from 'angular';

/* Configuration Imports */
import SiteRouteConfig from './sites.route';

//-- common components
import tableComponent from './common/table/table';
import mapComponent from './common/map/ga-map.component';
import ChartComponent from './common/chart/chart.component';
import appliedFiltersViewComponent from './common/applied-filters-view/applied-filters-view.component';
import SearchInputComponent from './common/search-input/search-input.component';
import SiteFiltersComponent from './common/site-filters/site-filters.component';
import UsersListView from './common/users-list-view/users-list-view.component';

/* Component Imports */
import sitesMainComponent from './sites-main.component';
import sitesListComponent from './sites-list/sites-list.component';
import siteViewComponent from './site-view/site-view.component';
import assetListViewComponent from './asset-list-view/asset-list-view.component';
import siteManageViewComponent from './site-manage-view/site-manage-view.component';

//--- services
import SiteService from './services/sites.service';
import FiltersService from './services/filters.service';

/* Module Imports */
import apiModule from '../../api/api.module';
import componentModules from '../../components/components.module';

const siteModule = angular.module('app.sites', [
  //INTERNAL
  apiModule,
  componentModules,
  //THIRD PARTY
  'ui.bootstrap',
  'ui.router',
  'gettext',
]);

siteModule
  /* Configurations */
  .config(SiteRouteConfig)

  /*   Services */
  .service('sitesService', SiteService)
  .service('filtersService', FiltersService)

  /* common */
  .component('zcTable', tableComponent)
  .component('siteMap', mapComponent)
  .component('zChart', ChartComponent)
  .component('appliedFiltersView', appliedFiltersViewComponent)
  .component('searchInput', SearchInputComponent)
  .component('siteFilters', SiteFiltersComponent)
  .component('usersListView', UsersListView)

  /* components */
  .component('sitesMain', sitesMainComponent)
  .component('sitesList', sitesListComponent)
  .component('siteView', siteViewComponent)
  .component('assetListView', assetListViewComponent)
  .component('siteManageView', siteManageViewComponent);

export default siteModule.name;
